module.exports = __webpack_public_path__ + "img/number_2.3d5bc6a9.svg";